<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- <div class="page-header">
                        <div class="d-flex">
                            <div class="justify-content-center">
                                <button type="button" class="btn btn-primary my-2 btn-icon-text floatright"
                                    (click)="addnewrecord('true')">
                                    Add New Record
                                </button>   
                            </div>
                        </div>
                    </div> -->
                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="ResultForm">
                            <div class="col-lg-12 col-md-12">
                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-8">
                                                <div class=" d-flex align-items-center pl-3">
                                                    <img alt="Logo" src="../../assets/img/CollegeMaster.png"
                                                        class="mh-45px pb-2">
                                                    <div class="ml-2">
                                                        <h3 class="main-content-label mb-1"><b>
                                                                Revaluation
                                                            </b></h3>
                                                        <p class="text-muted card-sub-title mb-0">
                                                            Revaluation
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div class="col-md-3">
                                              <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>{{ 'header.code-type-data.table.Search' | translate }}
                                                </mat-label> <input class="color" matInput placeholder="Search"
                                                  formControlName="SearchString">
                                                <mat-icon matSuffix>search</mat-icon>
                                              </mat-form-field>
                                            </div>
                                            <div class="col-md-1 prpl">
                                              <button id="New" type="button" class="btn btn-primary btn-icon-text  mt-1"
                                                (click)="addnewrecord()">
                                                <span style="display: flex; align-items: center;">
                                                  <img width="20vh" src="../../assets/img/plus.gif" style="margin-right: 5px;">
                                                  New
                                                </span>
                                              </button>
                                            </div> -->
                                        </div>
                                        <hr class="mt-2">
                                        <div class="row clearfix">
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>List</mat-label>
                                                        <!-- <input matInput formControlName="" placeholder="Exam" > -->
                                                        <mat-select formControlName="EcId" #select23 class="colorblack">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'"
                                                                [displayMember]="'item.ListDesc'" [array]="DataList"
                                                                (filteredReturn)=" filteredDataList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of  filteredDataList"
                                                                [value]="item.EcId" (click)="getListData(item)">
                                                                {{item.ListDesc}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['EcId'].touched && ResultForm.controls['EcId'].errors?.required">
                                                            Mandatory
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>User </mat-label>
                                                        <input matInput formControlName="listNo2" placeholder=""
                                                            readonly>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Description </mat-label>
                                                        <input matInput formControlName="listNo3" placeholder=""
                                                            readonly>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <!-- Next line -->

                                            <div class="col-sm-3 mt-1">
                                                <div class="form-group">
                                                    <div class="row">
                                                        <div class="col-sm-3 mt-3">
                                                            <mat-label class="mt-1 lclass"><span
                                                                    class="required-asterisk mr-1"></span>Valid</mat-label>
                                                        </div>
                                                        <div class="col-sm-7 mt-1">
                                                            <mat-radio-group formControlName="Valid"
                                                                class="example-full-width">
                                                                <div class="row">
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='Y'>Yes</mat-radio-button>
                                                                    </div>
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='N'>No</mat-radio-button>
                                                                    </div>
                                                                </div>
                                                            </mat-radio-group>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3 mt-1">
                                                <div class="form-group">
                                                    <div class="row">
                                                        <div class="col-sm-4 mt-3">
                                                            <mat-label class="mt-1 lclass"><span
                                                                    class="required-asterisk mr-1"></span>Changed</mat-label>
                                                        </div>
                                                        <div class="col-sm-7 mt-1">
                                                            <mat-radio-group formControlName="Chng"
                                                                class="example-full-width">
                                                                <div class="row">
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='Y'>Yes</mat-radio-button>
                                                                    </div>
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='N'>No</mat-radio-button>
                                                                    </div>
                                                                </div>
                                                            </mat-radio-group>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-1">
                                                <button type="button" class="btn btn-primary btn-icon-text  mt-1"
                                                    (click)="list()">
                                                    List
                                                </button>
                                            </div>
                                            <div class="col-sm-1">
                                                <button type="button" class="btn btn-primary btn-icon-text  mt-1">
                                                    Print
                                                </button>
                                            </div>
                                            <!-- <div class="col-sm-1" >
                                                <button type="button"
                                                class="btn btn-primary btn-icon-text  mt-1"
                                                (click)="icrbtn()">
                                                ICR
                                                </button>
                                            </div> -->
                                            <div class="col-sm-1">
                                                <button type="button" class="btn btn-primary btn-icon-text  mt-1">
                                                    Exit
                                                </button>
                                            </div>
                                        </div>
                                        <div *ngIf="afterList">
                                            <div class="row clearfix" *ngIf="Row1">

                                                <div class="col-sm-2">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Batch</mat-label>
                                                            <input matInput formControlName="Batch" placeholder=""
                                                                readonly>
                                                            <mat-error class="margin_tp"
                                                                *ngIf="ResultForm.controls['Batch'].touched && ResultForm.controls['Batch'].errors?.required">
                                                                Mandatory
                                                            </mat-error>
                                                            <mat-error class="margin_tp"
                                                                *ngIf="ResultForm.controls['Batch'].touched && ResultForm.controls['Batch'].errors?.pattern">
                                                                Enter Valid Data
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <!-- <div class="col-sm-4">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Exam</mat-label>
                                                        <input matInput formControlName="EmCode" placeholder=""  [readonly]="readOnlyFlag">
                                                        <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['EmCode'].touched && ResultForm.controls['EmCode'].errors?.pattern">
                                                            Enter Valid Data
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div> -->
                                                <div class="col-sm-2">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>W/H</mat-label>
                                                            <mat-select formControlName="ExcpCode" #select23
                                                                class="colorblack">

                                                                <mat-select-filter *ngIf="select23.focused"
                                                                    [placeholder]="'Filter'"
                                                                    [displayMember]="'item.CdDesc'"
                                                                    [array]="codeTypeList"
                                                                    (filteredReturn)=" filteredCodeType =$event"></mat-select-filter>
                                                                <mat-option value=""></mat-option>
                                                                <mat-option *ngFor="let item of  filteredCodeType"
                                                                    [value]="item.CdCode">
                                                                    {{item.CdCode}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="col-sm-2">
                                                    <!-- <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Set/Rem</mat-label>
                                                            <input matInput formControlName="SetRem" placeholder=""
                                                                maxlength="1">
                                                            <mat-error class="margin_tp"
                                                                *ngIf="ResultForm.controls['SetRem'].touched && ResultForm.controls['SetRem'].errors?.pattern">
                                                                Enter Valid Data
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div> -->
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Set/Rem</mat-label>
                                                            <mat-select formControlName="SetRem" #select23
                                                                class="colorblack">
                                                                <!-- <mat-select-filter *ngIf="select23.focused"
                                                                    [placeholder]="'Filter'"
                                                                    [displayMember]="'item.CdDesc'"
                                                                    [array]="codeTypeList"
                                                                    (filteredReturn)=" filteredCodeType =$event"></mat-select-filter> -->
                                                                <mat-option *ngFor="let item of setRemList"
                                                                    [value]="item.value">
                                                                    {{item.label}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row clearfix" *ngIf="Row2">
                                                <div class="col-sm-2">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Sub</mat-label>
                                                            <input matInput formControlName="Sub" placeholder=""
                                                                required>
                                                            <mat-error class="margin_tp"
                                                                *ngIf="ResultForm.controls['Sub'].touched && ResultForm.controls['Sub'].errors?.required">
                                                                Mandatory
                                                            </mat-error>
                                                            <mat-error class="margin_tp"
                                                                *ngIf="ResultForm.controls['Sub'].touched && ResultForm.controls['Sub'].errors?.pattern">
                                                                Enter Valid Data
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="col-sm-2">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Head</mat-label>
                                                            <input matInput formControlName="Head" placeholder="">
                                                            <mat-error class="margin_tp"
                                                                *ngIf="ResultForm.controls['Head'].touched && ResultForm.controls['Head'].errors?.required">
                                                                Mandatory
                                                            </mat-error>
                                                            <mat-error class="margin_tp"
                                                                *ngIf="ResultForm.controls['Head'].touched && ResultForm.controls['Head'].errors?.pattern">
                                                                Enter Valid Data
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>

                                                <div class="col-sm-2" *ngIf="Regno">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>RegnNo</mat-label>
                                                            <input matInput formControlName="RegnNo" placeholder=""
                                                                required>
                                                            <mat-error class="margin_tp"
                                                                *ngIf="ResultForm.controls['RegnNo'].touched && ResultForm.controls['RegnNo'].errors?.required">
                                                                Mandatory
                                                            </mat-error>
                                                            <mat-error class="margin_tp"
                                                                *ngIf="ResultForm.controls['RegnNo'].touched && ResultForm.controls['RegnNo'].errors?.pattern">
                                                                Enter Valid Data
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="col-sm-2" *ngIf="Rollno">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>RollNo</mat-label>
                                                            <input matInput formControlName="RollNo" placeholder="">
                                                            <mat-error class="margin_tp"
                                                                *ngIf="ResultForm.controls['RollNo'].touched && ResultForm.controls['RollNo'].errors?.required">
                                                                Mandatory
                                                            </mat-error>
                                                            <mat-error class="margin_tp"
                                                                *ngIf="ResultForm.controls['RollNo'].touched && ResultForm.controls['RollNo'].errors?.pattern">
                                                                Enter Valid Data
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="col-sm-2">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Marks</mat-label>
                                                            <input matInput formControlName="Marks" step="0.01"
                                                                placeholder="" required>
                                                            <mat-error class="margin_tp"
                                                                *ngIf="ResultForm.controls['Marks'].touched && ResultForm.controls['Marks'].errors?.required">
                                                                Mandatory
                                                            </mat-error>
                                                            <!-- <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['RollNo'].touched && ResultForm.controls['RollNo'].errors?.pattern">
                                                            Enter Valid Data
                                                        </mat-error> -->
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <!-- <div class="col-sm-1" >
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>MarksD</mat-label>
                                                        <input matInput formControlName="MarksD" placeholder="" [readonly]="readOnlyFlag">
                                                    </mat-form-field>
                                                </div>
                                            </div> -->
                                                <div class="col-sm-2">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Grade</mat-label>
                                                            <input matInput formControlName="Grade" placeholder="">
                                                            <mat-error class="margin_tp"
                                                                *ngIf="ResultForm.controls['Grade'].touched && ResultForm.controls['Grade'].errors?.pattern">
                                                                Enter Valid Data
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="row clearfix" *ngIf="Row3">
                                                <!-- <div class="col-sm-2">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Status</mat-label>
                                                            <input matInput formControlName="Status" placeholder="">
                                                            <mat-error class="margin_tp"
                                                                *ngIf="ResultForm.controls['Status'].touched && ResultForm.controls['Status'].errors?.pattern">
                                                                Enter Valid Data
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div> -->
                                                    <div class="col-sm-2">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Status</mat-label>
                                                            <mat-select formControlName="Status" #select23
                                                                class="colorblack">
                                                                <!-- <mat-select-filter *ngIf="select23.focused"
                                                                    [placeholder]="'Filter'"
                                                                    [displayMember]="'item.CdDesc'"
                                                                    [array]="codeTypeList"
                                                                    (filteredReturn)=" filteredCodeType =$event"></mat-select-filter> -->
                                                                <mat-option *ngFor="let item of statusList"
                                                                    [value]="item.value">
                                                                    {{item.label}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="col-sm-4">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Comment</mat-label>
                                                            <input matInput formControlName="Comment" placeholder="">
                                                            <mat-error class="margin_tp"
                                                                *ngIf="ResultForm.controls['Comment'].touched && ResultForm.controls['Comment'].errors?.pattern">
                                                                Enter Valid Data
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="col-sm-1">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Valid </mat-label>
                                                            <input matInput formControlName="Valid" placeholder=""
                                                                readonly>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="col-sm-4">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Message</mat-label>
                                                            <input matInput formControlName="Mesg" placeholder="">
                                                            <mat-error class="margin_tp"
                                                                *ngIf="ResultForm.controls['Mesg'].touched && ResultForm.controls['Mesg'].errors?.pattern">
                                                                Enter Valid Data
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="row mb-2 prpl">
                                                <div>
                                                    <button id="Save" type="button"
                                                        class="btn btn-primary btn-icon-text floatright mt-1"
                                                        (click)="submit()" *ngIf="submitButton">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="20vh" src="../../assets/img/save.gif"
                                                                style="margin-right: 5px;">
                                                            Save
                                                        </span>
                                                    </button>
                                                </div>
                                                <div>
                                                    <button id="Update" type="button"
                                                        class="btn btn-primary btn-icon-text floatright mt-1"
                                                        (click)="update()" *ngIf="editButton">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="20vh" src="../../assets/img/edit1.gif"
                                                                style="margin-right: 5px;">
                                                            Update
                                                        </span>
                                                    </button>
                                                </div>
                                                <div>
                                                    <button id="Delete" type="button"
                                                        class="btn btn-primary btn-icon-text floatright mt-1"
                                                        (click)="deleteRecord()" *ngIf="deleteButton">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="20vh" src="../../assets/img/trash.gif"
                                                                style="margin-right: 5px;">
                                                            Delete
                                                        </span>
                                                    </button>
                                                </div>
                                            </div>

                                            <!-- <div class="col-sm-12">
                                            <button type="button"
                                            class="btn btn-primary btn-icon-text floatright  mt-1"
                                                *ngIf="submitButton"
                                                (click)="submit()">Submit</button>
                                            <button type="button"
                                            class="btn btn-primary btn-icon-text floatright mt-1"
                                                *ngIf="editButton"
                                                (click)="update()">Update</button>
                                            <button type="button"
                                                class="btn btn-primary btn-icon-text floatright mt-1"
                                                *ngIf="deleteButton"
                                                (click)="deleteRecord()">Delete</button>
                                            <button type="button"
                                            class="btn btn-primary btn-icon-text floatright mt-1"
                                                (click)="back()">Back</button>
                                        </div> -->
                                            <div class="table-responsive">
                                                <table id="datatable"
                                                    class="table table-striped table-bordered text-nowrap text-left">
                                                    <thead>
                                                        <tr>

                                                            <!-- <th class="f600">
                                                            Ec
                                                        </th> -->
                                                            <th class="f600">
                                                                Batch
                                                            </th>
                                                            <th class="f600" *ngIf="Rollno">
                                                                RollNo
                                                            </th>
                                                            <th class="f600" *ngIf="Regno">
                                                                RegnNo
                                                            </th>
                                                            <th class="f600">
                                                                Sub
                                                            </th>
                                                            <th class="f600">
                                                                Head
                                                            </th>
                                                            <th class="f600">
                                                                Marks
                                                            </th>
                                                            <th class="f600">
                                                                MarksD
                                                            </th>
                                                            <th class="f600">
                                                                Grade
                                                            </th>
                                                            <th class="f600">
                                                                St
                                                            </th>
                                                            <th class="f600">
                                                                WH
                                                            </th>
                                                            <th class="f600">
                                                                S-R
                                                            </th>
                                                            <th>
                                                                Comment
                                                            </th>
                                                            <!-- <th>
                                                            PrevMarks
                                                        </th>
                                                        <th>
                                                            PrevResult
                                                        </th>
                                                        <th>
                                                            NewForm
                                                        </th>
                                                        <th>
                                                            HigherExams
                                                        </th> -->
                                                            <th>
                                                                Changed
                                                            </th>
                                                            <th>
                                                                Valid
                                                            </th>
                                                            <th>
                                                                Message
                                                            </th>
                                                            <!-- <th>
                                                            Exam
                                                        </th> -->
                                                            <th width="10%" class="f600 text-center">
                                                                {{'header.enrollment.table.Action' | translate}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="table_data">
                                                        <tr *ngFor="let result of gridList;">
                                                            <!--  -->
                                                            <!-- <td>
                                                            {{result.EcId}}
                                                        </td> -->
                                                            <td>
                                                                {{result.Batch}}
                                                            </td>
                                                            <td *ngIf="Rollno">
                                                                {{result.RollNo}}
                                                            </td>
                                                            <td *ngIf="Regno">
                                                                {{result.RegnNo}}
                                                            </td>
                                                            <td>
                                                                {{result.Sub}}
                                                            </td>
                                                            <td>
                                                                {{result.Head}}
                                                            </td>
                                                            <td>
                                                                {{result.Marks}}
                                                            </td>
                                                            <td>
                                                                {{result.MarksD}}
                                                            </td>
                                                            <td>
                                                                {{result.Grade}}
                                                            </td>
                                                            <td>
                                                                {{result.Status}}
                                                            </td>
                                                            <td>
                                                                {{result.ExcpCode}}
                                                            </td>
                                                            <td>
                                                                {{result.SetRem}}
                                                            </td>
                                                            <td>
                                                                {{result.Comment}}
                                                            </td>
                                                            <!-- <td>
                                                            {{result.PrevMarks}}
                                                        </td>
                                                        <td>
                                                            {{result.PrevResult}}
                                                        </td>
                                                        <td>
                                                            {{result.NewForm}}
                                                        </td>
                                                        <td>
                                                            {{result.HigherExams}}
                                                        </td> -->
                                                            <td>
                                                                {{result.Chng}}
                                                            </td>
                                                            <td>
                                                                {{result.Valid}}
                                                            </td>
                                                            <td>
                                                                {{result.Mesg}}
                                                            </td>
                                                            <!-- <td>
                                                            {{result.EmCode}}
                                                        </td> -->
                                                            <td class="text-center">

                                                                <a class="btn-floating" title="Edit"
                                                                    (click)="editData(result)">
                                                                    <i class="fa fa-edit"></i>
                                                                </a>
                                                                <a class="btn-floating" title="Delete"
                                                                    (click)="deleteData(result)">
                                                                    <i class="fas fa-trash"></i>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>